module.exports = __webpack_public_path__ + "d7d723a5c46a617e8602ba7629c2ba6b.svg";